const LIMIT = (89 * Math.PI) / 180;

/**
 * A touch drag turns the camera the way Babylon's mouse input does (spec 2p §3.2): yaw by pixels over the
 * angular sensibility, pitch by pixels times sensitivityY (negative when Y is inverted), pitch held to ±89°.
 */
export function applyLook(rot: { x: number; y: number }, dx: number, dy: number, p: { angularSensibility: number; sensitivityY: number }): void {
  rot.y += dx / p.angularSensibility;
  rot.x = Math.max(-LIMIT, Math.min(LIMIT, rot.x + dy * p.sensitivityY));
}

/** The gyro turns the camera by the angle the phone turned: radians as they are, pitch held to ±89°. */
export function applyTurn(rot: { x: number; y: number }, yaw: number, pitch: number): void {
  rot.y += yaw;
  rot.x = Math.max(-LIMIT, Math.min(LIMIT, rot.x + pitch));
}
